function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function setArrowsPosition() {
  const image_height = document.querySelector('.snippet__product-item--image-wrapper img').offsetHeight;
  // console.log(image_height)
  const splide_arrows = document.querySelectorAll('.section__featured-products .splide__arrow');

  // console.log(splide_arrows)
  splide_arrows.forEach((arrow) => (arrow.style.top = `${image_height / 2}px`));
}

const debouncedSetArrowsPosition = debounce(() => setArrowsPosition());

document.addEventListener('DOMContentLoaded', (event) => {
  setArrowsPosition();
});

window.addEventListener('resize', debouncedSetArrowsPosition);